import { NavigationButtonComponent } from '../../layout/components/navigation/buttons/navigation-button.component';
import { useSwitchPar } from '../../layout/hooks/switch-panel.hook';
import './back-to-demand.component.scss';

export const BackToDemandComponent = () => {
  const { show: path } = useSwitchPar('ret', '');
  if (path === '') return <></>;
  return (
    <div className="d-flex">
      <NavigationButtonComponent
        path={path}
        id={'Back-to-Demand-Model'}
        icon="arrow-left"
        name={'Back to Demand Model'}
        className={
          'btn-nav-link btn btn-animated border-radius-10 backToDemandModelButton'
        }
      />
    </div>
  );
};

export default BackToDemandComponent;
